import apiClient from '@shared/api/client';
import { ENDPOINTS } from '@shared/api/endpoints';

/**
 * 影片集 API Service
 * 彙整四個分類的影音來源：最新影音／文星點燈傳燈影音／文星點燈花絮／中台心傳花絮
 */

const WISDOM_LAMP_EVENT_ID = 1;
const JOINT_EXHIBITION_EVENT_ID = 4;
const TRANSMISSION_EVENT_ID = 5;

/**
 * 最新影音（section_id: 2）
 * 後端 list API 有分頁機制，帶一個夠大的 per_page 一次取回全部項目
 */
export const getLatestVideos = async () => {
  return apiClient.post(ENDPOINTS.LATEST_NEWS.LIST, { section_id: 2, });
};

/**
 * 文星點燈精舍傳燈影音
 * 後端 list API 有分頁機制，帶一個夠大的 per_page 一次取回全部項目
 */
export const getLightingPostVideos = async () => {
  return apiClient.post(ENDPOINTS.LAMP.LIGHTING_POST_LIST, { show_detail: false, per_page: 100 });
};

/**
 * 文星點燈精舍花絮影音
 * 後端 list API 有分頁機制，帶一個夠大的 per_page 一次取回全部項目
 */
export const getWisdomLampBehindScenes = async () => {
  return apiClient.post(ENDPOINTS.BEHIND_SCENES.LIST, { event_id: WISDOM_LAMP_EVENT_ID,  });
};

/**
 * 中台心傳精舍活動花絮
 * 後端 list API 有分頁機制，帶一個夠大的 per_page 一次取回全部項目
 */
export const getTransmissionBehindScenes = async () => {
  return apiClient.post(ENDPOINTS.BEHIND_SCENES.LIST, { event_id: TRANSMISSION_EVENT_ID });
};

/**
 * 聯展影片
 * 後端 list API 有分頁機制，帶一個夠大的 per_page 一次取回全部項目
 */
export const getJointExhibitionVideos = async () => {
  return apiClient.post(ENDPOINTS.BEHIND_SCENES.LIST, { event_id: JOINT_EXHIBITION_EVENT_ID });
};

export default {
  getLatestVideos,
  getLightingPostVideos,
  getWisdomLampBehindScenes,
  getTransmissionBehindScenes,
  getJointExhibitionVideos,
};
